/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'l4-policy';
const componentName = 'l4-rule-protocol-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const protocolMatchLabel = `${prefix}.protocolMatchLabel`;

export const ENGLISH = {
    [protocolMatchLabel]: 'Protocol',
};
